export class UserModel {
  userName: string;
  userId: string;
  role: string;

  constructor() {}
}

export class User {
  static fromJson(json: any): User {
    return new User(
      json.id,
      json.userName,
      json.name,
      json.firstName,
      json.lastName,
      json.email,
      json.streetAddress,
      json.city,
      json.state,
      json.zip,
      json.mobilePhone,
      json.homePhone,
      json.pager,
      json.lastLogin,
      json.active,
      ""
    );
  }

  static fromJsonArray(array): User[] {
    return array.map(User.fromJson);
  }

  constructor(
    public id: string,
    public userName: string,
    public name: string,
    public firstName: string,
    public lastName: string,
    public email: string,
    public streetAddress: string,
    public city: string,
    public state: string,
    public zip: string,
    public mobilePhone: string,
    public homePhone: string,
    public pager: string,
    public lastLogin: Date,
    public active: boolean,
    public password: string
  ) {}
}

export class UserResponse {
  public users: User[];
  public total: number;
}
